<script lang="ts">
    import {mainMenu} from "../../../stores/store";
    import {_} from "svelte-i18n";
    import { Navigation } from "../../utilities/Navigation";
    import MainMenuNotification from "./MainMenuNotification.svelte";

    export let item: any;

</script>

<!--<Link to={item.to}>{item.label}-->
    <button
            class="menu-item"
            class:active={$mainMenu.currentPage===item.id}
            on:click={() => Navigation.navigate(item.to)}
    >
        {#if item?.icon }
            <div class="menu-item__icon">
                <img alt={item.label} src={item?.icon} />
            </div>
        {/if}
        {#if $mainMenu.expanded}
            <span class="menu-item__label">{$_(item.label)}</span>
        {/if}
        {#if item?.notification}
            <MainMenuNotification id={item.id} notification={item.notification} currentPage={$mainMenu.currentPage===item.id}/>
        {/if}
    </button>
<!--</Link>-->

<style>
    .menu-item {
        position: relative;
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background-color: white;
        border: 0 solid #0005;
        border-radius: 5px;
        /*padding: 4px 19px 4px 10px;*/
        padding: 6px 12px;
        font-weight: 500;
        font-size: 13px;
        width: 100%;
        min-height: 36px;
        column-gap: 14px;
    }
    .menu-item.active {
        background-color: var(--main-selected-background);
        color: var(--main-selected-color);
        font-weight: 600;
    }
    .menu-item-end {
        /*align-self: flex-end;*/
        margin-top: auto;
    }
    .menu-item__icon {
        opacity: 0.7;
        /*margin-right: 14px;*/
        display: flex;
        align-items: center;
    }
    .active .menu-item__icon {
        filter: invert(20%) sepia(97%) saturate(1305%) hue-rotate(196deg) brightness(97%) contrast(93%);
    }
    .menu-item__label {
        text-align: left;
    }
</style>